import React, { useState, useEffect } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import AEATab from "./aea-tab/aea-tab";
import styles from "./aea-tabs.module.scss";

export interface IAEATabsProps {
  defaultTab?: any;
  children?: any;
  activeTab?(tab: any): void;
  idTour?: string;
}

const AEATabs = (props: IAEATabsProps) => {
  const [activeTab, setActiveTab] = useState(props.defaultTab);

  useEffect(()=>{
    if(props.activeTab !== undefined){
      props.activeTab(activeTab);
    }    
  }, [activeTab])  

  return (
    <div>
      <Nav className={styles.NavTabs} tabs>
        {props.children.map((child: any, i: number) => {
          return (
            <NavItem key={`ni-${i}`} className={styles.NavItem}>
              <NavLink
                key={`nl-${i}`}
                onClick={() => setActiveTab(i)}
                className={
                  activeTab !== i ? styles.NavLink : styles.NavLinkActive
                }
                id={`${(!!props.idTour && i === 1) ? props.idTour : ''}`}
              >
                {child.props.title}
              </NavLink>
            </NavItem>
          );
        })}
      </Nav>
      <TabContent activeTab={`${activeTab}`}>
        {props.children.map((child: any, i: number) => {
          return (
            <TabPane
              className={styles.TabPane}
              key={`tab-${i}`}
              tabId={`${i}`}
              tabIndex={i}
            >
              <AEATab active={activeTab == i ? true : false} {...child.props} id={``}></AEATab>
            </TabPane>
          );
        })}
      </TabContent>
    </div>
  );
};

export default AEATabs;
